import * as React from 'react';
import { useQuery } from 'react-query';
import { api } from 'services';
import type { BlockedProductReasonType } from 'contracts/blocked-products';

import { multiSelectorOptionsMapper, optionsMapper } from '../utils';

type ReasonTypeOption = {
  value: string;
  label: string;
}

export const useBlockedProductReasonTypeOptions = () => {
  const fetchReasons = React.useCallback(async (): Promise<ReasonTypeOption[]> => {
    const { data } = await api.get<BlockedProductReasonType[]>('/inventory/product-reason-types');
    return data.map(r => ({
      value: r.id.toString(),
      label: r.description,
    }));
  }, []);

  const { data, isLoading } = useQuery({
    queryKey: ['fetch-blocked-product-reason-types'],
    queryFn: fetchReasons,
    refetchOnWindowFocus: false,
  });

  return {
    singleSelectOptions: data?.map(optionsMapper) || [],
    multiSelectOptions: data?.map(multiSelectorOptionsMapper) || [],
    loading: isLoading,
  };
};
